import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import * as styles from "./Carousel.module.scss";
import { useLink } from "../../hooks";
import { Link } from "gatsby";

const Carousel = ({ items, renderItem, settings, title, buttonTestimonial }) => {
    const { showDots = true, showArrows = true } = settings || {};
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === items.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? items.length - 1 : prevIndex - 1
        );
    };

    const handleTouchStart = (e) => {
        const startX = e.touches[0].clientX;

        const handleTouchMove = (moveEvent) => {
            const moveX = moveEvent.touches[0].clientX;
            if (startX - moveX > 50) {
                nextSlide();
                document.removeEventListener("touchmove", handleTouchMove);
            } else if (moveX - startX > 50) {
                prevSlide();
                document.removeEventListener("touchmove", handleTouchMove);
            }
        };

        document.addEventListener("touchmove", handleTouchMove);
    };

    return (
        <section className={`container c-padding ${styles.carouselContainer}`}>
            {title && (
                <h2 className="global-spacing-bottom">
                    {title}
                </h2>
            )}

            <div className={styles.carousel} onTouchStart={handleTouchStart}>
                <div
                    className={styles.itemsWrapper}
                    style={{
                        transform: `translateX(-${currentIndex * 100}%)`,
                    }}
                >
                    {items.map((item, index) => (
                        <div className={styles.item} key={index}>
                            {renderItem(item)}
                        </div>
                    ))}
                </div>

                {showArrows && (
                    <>
                        <div
                            className={`${styles.arrow} ${styles.left} ${currentIndex === 0 ? styles.disabled : ""
                                }`}
                            onClick={prevSlide}
                        >
                            <FaChevronLeft />
                        </div>
                        <div
                            className={`${styles.arrow} ${styles.right} ${currentIndex === items.length - 1 ? styles.disabled : ""
                                }`}
                            onClick={nextSlide}
                        >
                            <FaChevronRight />
                        </div>
                    </>
                )}

                {showDots && (
                    <div className={styles.dots}>
                        {items.map((_, index) => (
                            <div
                                key={index}
                                className={`${styles.dot} ${index === currentIndex ? styles.active : ""}`}
                                onClick={() => setCurrentIndex(index)}
                            ></div>
                        ))}
                    </div>
                )}
            </div>

            {buttonTestimonial && (
                <Link
                    to={useLink(buttonTestimonial.slug)}
                    className="primaryFilled"
                    style={{ marginTop: "22px" }}
                    aria-label={
                        buttonTestimonial.title === "Learn more"
                        ? "Learn more about testimonials"
                        : `Go to ${buttonTestimonial.title}`
                    }
                >
                    {buttonTestimonial.title}
                </Link>
            )}

        </section>
    );
};

export default Carousel;
